<template>
  <g>
    <path
      d="M19.28 4.93018L17.16 2.81018C16.38 2.03018 15.11 2.03018 14.33 2.81018L11.5 5.64018L13.62 7.76018L15.74 5.64018L19.28 9.18018C20.45 8.00018 20.45 6.10018 19.28 4.93018Z"
    />
    <path
      d="M5.48999 13.7702C6.07999 14.3602 7.02999 14.3602 7.60999 13.7702L10.08 11.3002L7.95999 9.17018L5.48999 11.6402C4.89999 12.2302 4.89999 13.1802 5.48999 13.7702Z"
    />
    <path
      d="M14.33 8.46018L13.62 9.17018L10.44 5.99018C9.84997 5.40018 8.89997 5.40018 8.31997 5.99018C7.72997 6.58018 7.72997 7.53018 8.31997 8.11018L11.5 11.2902L4.49997 18.2902C3.79997 18.9902 3.61997 20.1302 4.20997 20.9402C4.94997 21.9702 6.39997 22.0602 7.25997 21.2002L16.45 12.0002C16.84 12.3902 17.47 12.3902 17.86 12.0002C18.25 11.6102 18.25 10.9802 17.86 10.5902L15.74 8.47018C15.35 8.07018 14.72 8.07018 14.33 8.46018Z"
    />
  </g>
</template>
